export { default as TeamNoAvatar } from './TeamNoAvatar';
